<template>
    <div>
        <KioskDashboard v-if="this.$store.state.isKiosk"></KioskDashboard>
        <ResellerDashboard v-else-if="this.$store.state.user.type < 3"></ResellerDashboard>
        <ClientDashboard v-else-if="this.$store.state.user.type == 3"></ClientDashboard>
    </div>
</template>

<script>
import ClientDashboard from './ClientDashboard'
import ResellerDashboard from './ResellerDashboard'
import KioskDashboard from '../Kiosk/KioskDashboard'
export default {
    name: 'SharedDashboard',
    data() {
        return {
        }
    },
    components:{
        ResellerDashboard,
        ClientDashboard,
        KioskDashboard
    },
    mounted(){
        let _this = this;
        setTimeout(function(){
            if(_this.$store.state.isLogged && $('body').hasClass('loginWrap')) document.body.className = (_this.$store.state.preferences.menuState == 'open' ? 'menu_open' : '');
        },700);
    },

    beforeMount(){
        if(!this.$store.state.kioskEvent.id) {
            this.$store.dispatch('getDashboardData')
                .catch(err => {
                    //err
                    this.$router.push('/login')
                })
        }
    }
}

</script>
